export { UserAvatarGroup } from './user-avatar-group';
